import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative py-20 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20curves%20and%20geometric%20shapes%20in%20amber%20and%20coral%20tones%2C%20elegant%20modern%20design%2C%20smooth%20texture%2C%20no%20text%20or%20sharp%20edges&width=1800&height=700&seq=cta-bg-asia-02&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/85"></div>
      <div className="relative max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
          准备好开启亚洲之旅了吗？
        </h2>
        <p className="text-base md:text-lg text-white/70 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed">
          加入亚洲在线，与500万用户一起探索亚洲各地的优质资源与精彩内容，发现属于您的无限可能。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3.5 bg-primary-500 text-white text-sm md:text-base font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即加入
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-transparent text-white text-sm md:text-base font-medium rounded-full border border-white/30 hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}